import * as HTTP from './http';

export const Create = async(data, token) => {
    let endpoint = `orders/create`;

    try{
        var result = await HTTP.POST_FILE(endpoint, data, token);
    }catch(e){
        console.log(`CONTROLLER ERROR: orders.create\n${e}`);
        return undefined;
    }

    return result;
}

export const Send = async(token, file) => {
    let endpoint = `orders/catch`;

    try{
        var result = await HTTP.POST_FILE(endpoint, file, token);
    }catch(e){
        console.log(`CONTROLLER ERROR: orders.catch\n${e}`);
        return undefined;
    }

    return result;
}

export const List = async (token) => {
    let endpoint = `orders/list`;

    try{
        var result = await HTTP.GET(endpoint, token);
    }catch(e){
        console.log(`CONTROLLER ERROR: orders.list\n${e}`);
        return undefined;
    }

    return result;
}

export const GetDetailByCompany = async(token) => {
    let endpoint = `orders/company/detail/`;

    try{
        var result = await HTTP.GET(endpoint, token);
    }catch(e){
        console.log(`CONTROLLER ERROR: orders.GetDetailByCompany\n${e}`);
        return undefined;
    }

    return result;
}

export const GetCsvReport = async(token, dates, statuses) => {
    const datesValue = encodeURIComponent(JSON.stringify(dates));
    const statusesValue = encodeURIComponent(JSON.stringify(statuses));
    let endpoint = `orders/company/report/${statusesValue}/${datesValue}`;

    try{
        var result = await HTTP.GET_CSV(endpoint, token);
    }catch(e){
        console.log(`CONTROLLER ERROR: orders.GetCsvRerport\n${e}`);
        return undefined;
    }

    return result;
}

export const GetById = async(id) => {
    let endpoint = `orders/id/${id}`;

    try{
        var result = await HTTP.GET(endpoint);
    }catch(e){
        console.log(`CONTROLLER ERROR: orders.GetById\n${e}`);
        return undefined;
    }

    return result;
}

export const GetDetailByAll = async(token, page) => {
    const pageNumber = page - 1
    let endpoint = `orders/detail/all/${pageNumber}`;

    try{
        var result = await HTTP.GET(endpoint, token);
    }catch(e){
        console.log(`CONTROLLER ERROR: orders.GetDetailByAll\n${e}`);
        return undefined;
    }

    return result;
}

export const GetDetailFull = async(order) => {
    let endpoint = `orders/detail/full/${order}`;

    try{
        var result = await HTTP.GET(endpoint);
    }catch(e){
        console.log(`CONTROLLER ERROR: orders.GetDetailFull\n${e}`);
        return undefined;
    }

    return result;
}

export const GetEditableInfo = async(order, token) => {
    const endpoint = `orders/${order}/info-edit`;

    try{
        return await HTTP.GET(endpoint, token);
    }catch(e){
        console.log('CONTROLLER ERROR: orders.GetEditableInfo');
        return undefined;
    }
}

export const UpdateEditableInfo = async(order, body, token) => {
    const endpoint = `orders/${order}/info`;

    try{
        return await HTTP.PATCH(endpoint, body, token);
    }catch(e){
        console.log('CONTROLLER ERROR: orders.UpdateEditableInfo');
        return undefined;
    }
}

export const UpdateDataGeneralFree = async (body) => {
    let endpoint = `orders/update/datageneral/free`;

    try{
        var result = await HTTP.PUT(endpoint, body);
    }catch(e){
        console.log(`CONTROLLER ERROR: orders.UpdateDataGeneralFree\n${e}`);
        return undefined;
    }

    return result;
}

export const Cancelation = async (body, token) => {
    let endpoint = `orders/cancelation`;

    try{
        var result = await HTTP.PUT(endpoint, body, token);
    }catch(e){
        console.log(`CONTROLLER ERROR: orders.Cancelation\n${e}`);
        return undefined;
    }

    return result;
}

export const GetProductionCsvReport = async(token,dates, statuses, clients) => {
    const datesValue = encodeURIComponent(JSON.stringify(dates));
    const statusesValue = encodeURIComponent(JSON.stringify(statuses));
    const clientsValue = encodeURIComponent(JSON.stringify(clients));

    let endpoint = `orders/production/report/${statusesValue}/${datesValue}/${clientsValue}`;
    
    try{
        var result = await HTTP.GET_CSV(endpoint, token);
    }catch(e){
        console.log(`CONTROLLER ERROR: orders.GetProductionCsvReport\n${e}`);
        return undefined;
    }

    return result;
}

export const UpdateStatus = async (body, token) => {
    let endpoint = `orders/update/status`;

    try{
        var result = await HTTP.PUT(endpoint, body, token);
    }catch(e){
        console.log(`CONTROLLER ERROR: orders.UpdateStatus\n${e}`);
        return undefined;
    }

    return result;
}

export const GetByReference = async(orderRef) => {
    let endpoint = `orders/reference/${encodeURIComponent(orderRef)}`;

    try{
        var result = await HTTP.GET(endpoint);
    }catch(e){
        console.log(`CONTROLLER ERROR: orders.GetByReference\n${e}`);
        return undefined;
    }

    return result;
}

// region GetTracingReport
export const GetTracingReport = async() => {
    let endpoint = `orders/tracing/report`;

    try{
        var result = await HTTP.GET(endpoint);
    }catch(e){
        console.log(`CONTROLLER ERROR: orders.GetTracingReport\n${e}`);
        return undefined;
    }

    return result;
}

// region GetBySerial
export const GetBySerial = async(id) => {
    let endpoint = `orders/serial/${id}`;

    try{
        var result = await HTTP.GET(endpoint);
    }catch(e){
        console.log(`CONTROLLER ERROR: orders.GetBySerial\n${e}`);
        return undefined;
    }

    return result;
}

// region SetComplete
export const SetComplete = async(payload) => {
    let endpoint = `orders/complete`;

    try{
        var result = await HTTP.POST(endpoint, payload);
    }catch(e){
        console.log(`CONTROLLER ERROR: orders.SetComplete\n${e}`);
        return undefined;
    }

    return result;
}

// region Files
export const GetFiles = async(order) => {
    let endpoint = `orders/files/${order}`;

    try{
        var result = await HTTP.GET(endpoint);
    }catch(e){
        console.log(`CONTROLLER ERROR: orders.GetFiles\n${e}`);
        return undefined;
    }

    return result;
}

export const DownloadFilesZip = async(order, type = 'all') => {
    let endpoint = `orders/files/${order}/zip?type=${encodeURIComponent(type)}`;

    try{
        var result = await HTTP.GET_CSV(endpoint);
    }catch(e){
        console.log(`CONTROLLER ERROR: orders.DownloadFilesZip\n${e}`);
        return undefined;
    }

    return result;
}

export const DownloadFile = async(order, filename) => {
    let endpoint = `orders/file/${order}/${encodeURIComponent(filename)}`;

    try{
        var result = await HTTP.GET_CSV(endpoint);
    }catch(e){
        console.log(`CONTROLLER ERROR: orders.DownloadFile\n${e}`);
        return undefined;
    }

    return result;
}

export const UploadFiles = async(order, formData, token) => {
    let endpoint = `orders/files/${order}`;

    try{
        var result = await HTTP.POST_FILE(endpoint, formData, token);
    }catch(e){
        console.log(`CONTROLLER ERROR: orders.UploadFiles\n${e}`);
        return undefined;
    }

    return result;
}

export const GetProductionPage = async(token, page, filters) => {
    const params = new URLSearchParams({page: String(page), ...filters});
    try { return await HTTP.GET('production-orders?' + params.toString(), token); }
    catch (_) { return {success:false}; }
};
